import React, { useEffect, useRef, useState } from 'react'
import HTMLFlipBook from 'react-pageflip';
import * as pdfjsLib from 'pdfjs-dist';
import bgImg from "../../../../../../assets/windTree/images/login/gp-brown.webp"
import { ArrowBigLeftIcon, ArrowBigRightIcon, Download } from 'lucide-react';
import pageFlipSound from "../../../../../../assets/windTree/sound/page-flip.mp3"

pdfjsLib.GlobalWorkerOptions.workerSrc =
    `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjsLib.version}/pdf.worker.min.mjs`;
// const PDF_FILE = book;

console.log("PDF.js version:", pdfjsLib.version);
console.log(
    "Worker URL:",
    `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjsLib.version}/pdf.worker.min.mjs`
);

export default function Flipbook() {
    const [pages, setPages] = useState([]);
    const [loading, setLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(0);
      const [error, setError] = useState("");
      const audioRef = useRef(null);

      const [bookSize, setBookSize] = useState({
        width:450,
        height: 600,
      })

      const [isPortrait, setIsPortrait] = useState(false);

      const downloadPDF = () => {
        const pdfUrl = "https://wn-new-collections.zohostratus.in/organized_1.pdf";

        const link = document.createElement("a");
        link.href = pdfUrl;
        link.download = "WindTree-Brochure.pdf";
        link.target = "_blank";

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      };

    const bookRef = useRef(null);

    useEffect(() => {
        const audio = new Audio(pageFlipSound);
        audio.preload = "auto";
        audio.load();
        audioRef.current = audio;
    }, []);

    useEffect(() => {
        const updateBookSize = () => {
            const width = window.innerWidth;

            if (width < 640) {
                setBookSize({
                    width: Math.min(width - 40, 300),
                    height:Math.min((width - 40) * 1.33, 520),
                });
                setIsPortrait(true);
            } else if (width < 1024) {
                setBookSize({
                    width: Math.min(width - 100, 500),
                    height: Math.min((width - 100) * 1.33, 650),
                });
                setIsPortrait(true);
            } else {
                setBookSize({
                    width: 450,
                    height: 600,
                });
                setIsPortrait(false);
            }
        };
        updateBookSize();

        window.addEventListener("resize", updateBookSize);

        return () => {
            window.removeEventListener("resize", updateBookSize);
        };
    }, []);


    useEffect(() => {
        loadPDF();
    }, []);

    const loadPDF = async () => {
        try {
            setLoading(true);
             setError("");

      console.log("PDF URL:", "https://wn-new-collections.zohostratus.in/organized_1.pdf");

            const loadingTask = pdfjsLib.getDocument({ url: "https://wn-new-collections.zohostratus.in/organized_1.pdf" });
            const pdf = await loadingTask.promise;

            const renderedPages = [];

            for (let pageNumber = 1; pageNumber <= pdf.numPages; pageNumber++) {
                const page = await pdf.getPage(pageNumber);

                const viewport = page.getViewport({
                    scale: 2,
                });

                const canvas = document.createElement("canvas");
                const context = canvas.getContext("2d");

                canvas.width = viewport.width;
                canvas.height = viewport.height;

                await page.render({
                    canvasContext: context,
                    viewport,
                }).promise;

                renderedPages.push(canvas.toDataURL("image/png"));
            }
            setPages(renderedPages);
        } catch (error) {
             console.error("PDF loading error:", error);
        } finally {
             setLoading(false);
        }
    };

    const nextPage = () => {
        bookRef.current?.pageFlip()?.flipNext();
    }

    const previousPage = () => {
        bookRef.current?.pageFlip()?.flipPrev();
    };

    const handleFlip = (e) => {
        setCurrentPage(e.data);

    //     const audio = audioRef.current;
      
    //     if (audio) {
    //     audio.currentTime = 0;

    //     audio.play().catch((error) => {
    //         console.log("Page flip sound could not play:", error);
    //     });
    // }
    };

    const handleStateChange = (e) => {
        if (e.data === "flipping") {
            const audio = audioRef.current;
            if (audio) {
                audio.currentTime = 0;
                audio.play().catch(() => {});
            }
        }
    };


  return (
     <div className="min-h-screen w-full relative overflow-hidden">
           {/* ================= BACKGROUND ================= */}
             <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `
            linear-gradient(
              rgba(255,255,255,0.15),
              rgba(255,255,255,0.15)
            ),
            url(${bgImg})
          `,
        }}
      />

      <div className="absolute inset-0 bg-black/5 backdrop-blur-[1px]"/>
          <button
        type="button"
        onClick={downloadPDF}
        className="
            flex items-center gap-2
            px-4 py-2.5 mt-4 ml-auto mr-11
            backdrop-blur-md
            text-md
            shadow-lg
             border-2 border-[#D1BC9F] rounded-md text-[#661E33] font-bold cursor-pointer hover:text-white hover:bg-[#661E33] transition-all duration-300 whitespace-nowrap 
        "
    >
        <Download className="w-4 h-4" />
        Download PDF
    </button>

      {/* ================= CONTENT ================= */}
      <div className="relative z-10 min-h-screen flex flex-col items-center justify-center">
        
        {loading ? (
            <div className="flex flex-col items-center gap-4">
                  <div className="h-10 w-10 rounded-full border-4 border-white/40 border-t-white animate-spin" />

                <p className="text-white text-sm font-medium drop-shadow">Loading Flipbook...</p>

            </div>
        ) : (
            <>
            <div className="relative">
                <HTMLFlipBook
                 ref={bookRef}
                 width={bookSize.width}
                 height={bookSize.height}
                 size="fixed"

                 
                minWidth={300}
                maxWidth={600}
                minHeight={400}
                maxHeight={800}

                showCover={true}
                mobileScrollSupport={true}

                usePortrait={isPortrait}
                startPage={0}

                drawShadow={true}
                maxShadowOpacity={0.45}

                flippingTime={900}

                startZIndex={10}

                autoSize={false}
                clickEventForward={true}
                useMouseEvents={true}

                swipeDistance={30}

                showPageCorners={true}

                onFlip={handleFlip}
                onChangeState={handleStateChange}
                
                className="flip-book"

                >

                    {pages.map((page, index) => (
                        <div key={index} className="w-full h-full flex items-center justify-center bg-white overflow-hidden">
                            <img src={page} alt={`Brochure page ${index + 1}`}
                            className="w-full h-full object-contain select-none"
                            draggable="false"
                            />
                        </div>
                    ))}

                </HTMLFlipBook>


                {/* Left Arrow */}

                {currentPage > 0 && (
                    <button type="button" onClick={previousPage}
                    className=" absolute
                    left-[-55px]
                    top-1/2
                    -translate-y-1/2
                    w-10
                    h-10
                    rounded-md
                    bg-black/75
                    text-white
                    flex
                    items-center
                    justify-center
                    text-2xl
                    shadow-lg
                    hover:bg-black
                    transition-all
                    duration-200
                    z-50">
                        <ArrowBigLeftIcon className="w-6 h-6" />
                    </button>
                )}

                {currentPage < pages.length - 1 && (
                    <button 
                    type="button"
                     onClick={nextPage}
                      className="  absolute
                    right-[-55px]
                    top-1/2
                    -translate-y-1/2
                    w-10
                    h-10
                    rounded-md
                    bg-black/75
                    text-white
                    flex
                    items-center
                    justify-center
                    text-2xl
                    shadow-lg
                    hover:bg-black
                    transition-all
                    duration-200
                    z-50">
                        <ArrowBigRightIcon className="w-6 h-6" />
                    </button>
                )}
            </div>

            <div className="mt-2
                px-5
                py-2
                rounded-full
                bg-black/60
                backdrop-blur-md      
                text-white
                text-sm
                shadow-lg">
                Page {currentPage + 1} / {pages.length}
            </div>

            </>
        )}
      </div>
     </div>
  )
}